import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Footer from '@/components/common/footer.vue';
import Header from '@/components/common/header.vue';
import { getWei } from '@/utils/connect';
import Email from '@/api/modules/email';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
// import {fetchGasPrice} from '@kolirt/vue-web3-auth'
import { walletConnectDisAble } from '@/utils/connect';
import QueryApi from '@/api/modules/query';
import CommomApi from '@/api/modules/commom';
export default {
  name: 'App',
  components: {
    Footer: Footer,
    Header: Header
  },
  data: function data() {
    return {
      chainIdListStatus: false
    };
  },
  watch: {
    chainid: {
      handler: function handler(to, from) {
        var _this = this;
        if (to || from) {
          this.$store.commit('setShoppingCartNumber');
          if (to) {
            getWei();
            if (this.getChainsList) {
              if (this.getChainsList[to]) {
                if (this.getChainsList[to].showFlag != 1) {
                  setTimeout(function () {
                    localStorage.removeItem('token');
                    sessionStorage.removeItem('account');
                    _this.$store.commit('setAccount', '');
                    _this.$store.commit('setAccessToken', '');
                    _this.$store.commit('setPrimaryName', '');
                    walletConnectDisAble();
                  }, 2000);
                }
              }
            }
          }
        }
      },
      deep: true,
      immediate: true
    },
    account: {
      handler: function handler(to, from) {
        if (to) {
          this.setRemain();
          if (to != localStorage.getItem('tokenAccount')) {
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('emailList');
            localStorage.removeItem('tokenAccount');
            this.$store.commit('setAccessToken', '');
          }
        }
      },
      deep: true,
      immediate: true
    },
    getChainsList: {
      handler: function handler(to, from) {
        var _this2 = this;
        if (to) {
          if (this.chainid) {
            if (this.getChainsList[this.chainid]) {
              if (this.getChainsList[this.chainid].showFlag != 1) {
                setTimeout(function () {
                  localStorage.removeItem('token');
                  sessionStorage.removeItem('account');
                  _this2.$store.commit('setAccount', '');
                  _this2.$store.commit('setAccessToken', '');
                  _this2.$store.commit('setPrimaryName', '');
                  walletConnectDisAble();
                }, 2000);
              }
            }
          }
        }
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (sessionStorage.getItem('account')) {
      if (window.ethereum) {
        this.$initWallet();
      }
    }
    if (!sessionStorage.getItem('isNew') && !window.ethereum) {
      sessionStorage.setItem('isNew', 1);
      window.location.reload();
    }
  },
  computed: _objectSpread({}, mapState(['chainid', 'account', 'isMobile', 'footVisible', 'getChainsList'])),
  mounted: function mounted() {
    this.$store.commit('setShoppingCartNumber');
    this.getCfgToken();
    this.getWaletsList();
    this.getChainsLists();
  },
  // CommomApi
  methods: {
    setRemain: function setRemain() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var json, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              json = {
                bizType: 1
              };
              _context.prev = 1;
              _context.next = 4;
              return Email.getEmailReminder(json);
            case 4:
              res = _context.sent;
              localStorage.setItem('emailList', JSON.stringify(res));
              _context.next = 10;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    getCfgToken: function getCfgToken() {
      var _this3 = this;
      QueryApi.getCfgToken().then(function (res) {
        var json = {};
        for (var i in res) {
          json[res[i].id] = res[i];
        }
        _this3.$store.commit('setCfgTokenList', json);
      })["catch"](function (err) {
        console.log('geTldData.err=', err);
      });
    },
    getWaletsList: function getWaletsList() {
      var _this4 = this;
      CommomApi.getWalets().then(function (res) {
        var json = {};
        res.forEach(function (item) {
          json["".concat(item.walletName)] = item;
        });
        _this4.$store.commit('setWaletsList', json);
      })["catch"](function (err) {
        console.log('geTldData.err=', err);
      });
    },
    getChainsLists: function getChainsLists() {
      var _this5 = this;
      CommomApi.getChains().then(function (res) {
        if (res) {
          _this5.chainIdListStatus = true;
          var json = {};
          res.forEach(function (item) {
            json[item.chainId] = item;
          });
          _this5.$store.commit('setChainsList', json);
          localStorage.setItem('setChainsList', JSON.stringify(json));
        }
      })["catch"](function (err) {
        console.log('geTldData.err=', err);
      });
    }
  }
};